<div class="descriptionActivity" [class.activityChange__comment]="ppComment">
  <span (ppOnRendered)="initEditor($event)"></span>

  @if (!expanded && long) {
    <span
      class="ppLink activityChange__show-more-less"
      (click)="expandDescription()"
      >
      {{ 'show_more' | ppTranslate }}
    </span>
  }

  @if (expanded && long) {
    <span
      class="ppLink activityChange__show-more-less"
      (click)="collapseDescription()"
      >
      {{ 'show_less' | ppTranslate }}
    </span>
  }
</div>
